import * as React from "react";
import { forwardRef } from "react";
const SvgTitleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.25 15H3.75C2.50725 15 1.5 13.9928 1.5 12.75V3.75H14.25C15.4928 3.75 16.5 4.75725 16.5 6V12.75C16.5 13.9928 15.4928 15 14.25 15Z", fill: "#2196F3" }), /* @__PURE__ */ React.createElement("path", { d: "M8.25 3.75H1.5V3C1.5 2.17125 2.17125 1.5 3 1.5H6.4185C7.06425 1.5 7.63725 1.91325 7.84125 2.526L8.25 3.75Z", fill: "#90C9F9" }));
const ForwardRef = forwardRef(SvgTitleIcon);
export { ForwardRef as ReactComponent };
